
<!--primera fila-->
<div class="row" [ngClass]="{'similar': hasSimilar}">
  <h4 *ngIf="loadingStock" style="margin-left: 15px;">{{language.CARGANDO}}</h4>
  <h4 *ngIf="!loadingStock && !stock.length" style="margin-left: 15px;">{{language.NO_RESULTS_TITLE}}</h4>
  <div *ngFor="let item of stock" class="col-md-6 col-sm-12 col-xs-12 mosaic-detail-ipad" (click)="selectStock(item)" >
    <div class="row mosaic-animation animate__animated animate__fadeIn">
      <div class="col-sm-6 col-xs-12 detail-image">
        <div class="img-mosaic-detail animate__animated animate__fadeIn">
          <div class="img-mosaic-title">
            <span>{{getNombreMaterial(item.MATERIAL)}}</span>
          </div>
          <div class="mosaic-img-container" [style.background-image]="'url('+item.IMAGENMINIURL+')'"></div>
        </div>
      </div>
      <div class="col-sm-6 col-xs-12 detail-data">
        <div class="data-mosaic-title">
          <span *ngIf="true">{{language.BLOQUE_TEXT}} {{item.BLOQUE || 'N/A'}}</span>
          <span *ngIf="false">{{language.PAQUETE_TITLE}} {{item.GRUPO || 'N/A'}}</span>
          <div *ngIf="item.LIBRO == 1" class="bookmatch-results">
            <span>Bookmatch</span>
          </div>
        </div>
        <!--table detail-->
        <div class="table-separator"></div>
        <table>
          <!-- <tr>
            <td>
              <span>{{language.BLOQUE_TEXT}}</span>
            </td>
            <td class="description">
              <span>{{item.BLOQUE || 'N/A'}}</span>
            </td>
          </tr> -->
          <tr>
            <td>
              <span>{{language.ACBABADO_DELTALLE_TITLE}}</span>
            </td>
            <td class="description">
              <span>{{getAcabadoMaterial(item.ACABADO)}}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>{{language.TIPO_MATERIAL_DELTALLE_TITLE}}</span>
            </td>
            <td class="description">
              <span>{{getNombreTipoMaterial(item.MATERIAL)}}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>{{language.DISPONIBILIDAD_FILTER_TITLE}}</span>
            </td>
            <td class="description">
              <span>{{getDisponibilidad(item.DISPONIBILIDAD)}}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>{{language.COLOR_MATERIAL_DELTALLE_TITLE}}</span>
            </td>
            <td class="description">
              <span>{{getColorMaterial(item.MATERIAL)}}</span>
            </td>
          </tr>
          </table>
          <div class="table-separator"></div>
          <table>
          <tr>
            <td>
              <span *ngIf="item.MAXLARGO != item.MINLARGO">{{language.RANGO_ANCHO_DELTALLE_TITLE}}</span>
              <span *ngIf="item.MAXLARGO == item.MINLARGO">{{language.ANCHO_MATERIAL_TITLE}}</span>
            </td>
            <td class="description">
              <span *ngIf="item.MAXLARGO != item.MINLARGO">{{getRangoAnchura(item)}}</span>
              <span *ngIf="item.MAXLARGO == item.MINLARGO">{{getMedidaAncho(item)}}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span *ngIf="item.MAXALTO != item.MINALTO">{{language.RANGO_ALTO_DELTALLE_TITLE}}</span>
              <span *ngIf="item.MAXALTO == item.MINALTO">{{language.ALTO_MATERIAL_TITLE}}</span>
            </td>
            <td class="description">
              <span *ngIf="item.MAXALTO != item.MINALTO">{{getRangoAltura(item)}}</span>
              <span *ngIf="item.MAXALTO == item.MINALTO">{{getMedidaAlto(item)}}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>{{language.ESPESOR_MATERIAL_DELTALLE_TITLE}}</span>
            </td>
            <td class="description">
              <span>{{getMedida(item.ANCHO)}}</span>
            </td>
          </tr>          
        </table>
        <div class="table-separator"></div>
        <table style="text-transform: uppercase;">
          <tr >
            <td>
              <span>{{language.PIEZAS_DELTALLE_TITLE}}</span>
            </td>
            <td class="description">
              <span>{{getPiezas(item.PIEZAS)}}</span>
            </td>
            <td *ngIf="groupByBundle" class="description" style="width: 100%;">
              <div style="float: right;">
              <span>{{item.NUMPAQUETES}} {{(item.NUMPAQUETES > 1) ? language.PAQUETES_TITLE : language.PAQUETE_TITLE}}</span>
              </div>
            </td>
          </tr>
        </table>
        <div class="table-separator"></div>
        <!--table detail-->
      </div>
    </div>
    <br>
  </div>
</div>
<!--final tercera fila-->
